import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/del.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1b536a66")

_pushScopeId("data-v-1b536a66")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = { class: "flex alignC mar-b-30 mar-l-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "padding-30" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "width-211" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { style: {} }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "flex flexC alignC mar-t-22" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_26 = { class: "dialog-content" }
const _hoisted_27 = { class: "flex dialog-screen" }
const _hoisted_28 = { class: "flex flexC form-button" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "立即创建", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "c-60 w-500" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_editList = _resolveComponent("editList")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      (_ctx.navindex == 1 || _ctx.navindex == 3 || _ctx.navindex == 4)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.formRules,
              inline: true,
              "label-width": "120px",
              class: "width-900"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_6, [
                  (_ctx.navindex == 4)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "单据日期",
                        prop: "date"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "width-211",
                            modelValue: _ctx.form.date,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.date = $event)),
                            type: "date",
                            placeholder: "选择日期"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "单据日期"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, { class: "width-211" }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.date), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_el_form_item, {
                    label: "采购员",
                    prop: "employee_id"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.employee_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.employee_id = $event)),
                        placeholder: "请选择",
                        class: "width-211"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PurchaseManList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.nickname,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", null, [
                  (_ctx.navindex == 4)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "供应商",
                        prop: "supplier_id"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.form.supplier), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "供应商",
                        prop: "supplier_id"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.supplier_id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.supplier_id = $event)),
                            placeholder: "请选择",
                            class: "width-211"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.supplier_name,
                                  value: item.supplier_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_el_form_item, { label: "实际采购单号" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        class: "width-211",
                        modelValue: _ctx.form.purchase_sh,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.purchase_sh = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_el_form_item, { label: "备注" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"600px"},
                        modelValue: _ctx.form.purchase_desc,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.purchase_desc = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.navindex == 2)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.formRules,
              inline: true,
              "label-width": "80px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "单据日期",
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, { class: "width-211" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.date), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "维修车辆",
                  "label-width": "80px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.car_dialog_show = true)),
                      class: "width-211"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.car_name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "采购员",
                  prop: "employee_id",
                  "label-width": "80px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.employee_id,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.employee_id = $event)),
                      placeholder: "请选择",
                      class: "width-211"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PurchaseManList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.nickname,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "供应商",
                  prop: "supplier_id",
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.supplier_id,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.supplier_id = $event)),
                      placeholder: "请选择",
                      class: "width-211"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.supplier_name,
                            value: item.supplier_id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "实际采购单号",
                  "label-width": "400px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      class: "width-211",
                      modelValue: _ctx.form.purchase_sh,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.purchase_sh = $event)),
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "备注",
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"600px"},
                      modelValue: _ctx.form.purchase_desc,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.purchase_desc = $event)),
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.navindex == 4)
        ? (_openBlock(), _createBlock(_component_editList, {
            key: 2,
            partsData: _ctx.form.parts,
            show_add: false
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                label: "配件名称",
                width: "250"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_9, _toDisplayString(scope.row.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "规格",
                width: "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_10, _toDisplayString(scope.row.specification), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "配件分类",
                width: "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_11, _toDisplayString(scope.row.mountings_type_pname), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "品牌",
                width: "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_12, _toDisplayString(scope.row.mountings_brand_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "单位",
                width: "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_13, _toDisplayString(scope.row.unit), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "采购单价",
                width: "125"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_14, _toDisplayString(scope.row.cost_price), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "采购数量",
                width: "125"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_15, _toDisplayString(scope.row.member), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "已退",
                width: "125"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_16, _toDisplayString(scope.row.return_number_), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "可退",
                width: "125"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_17, _toDisplayString(scope.row.stock_number), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "退货数量",
                width: "125"
              }, {
                default: _withId((scope) => [
                  _createVNode(_component_el_input, {
                    modelValue: scope.row.return_number,
                    "onUpdate:modelValue": ($event: any) => (scope.row.return_number = $event),
                    type: "text",
                    class: "mar-l-16",
                    style: {"width":"80px"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["partsData"]))
        : (_openBlock(), _createBlock(_component_editList, {
            key: 3,
            partsData: _ctx.form.parts,
            show_add: true,
            onBtn_add: _ctx._editlist_add
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                label: "配件名称",
                width: "250"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("img", {
                      onClick: ($event: any) => (_ctx._defItem(scope.$index)),
                      src: _imports_0,
                      class: "wh-24"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      class: "mar-l-16",
                      style: {"width":"160px"}
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "规格",
                "min-width": "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_19, _toDisplayString(scope.row.specification), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "配件分类",
                "min-width": "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_20, _toDisplayString(scope.row.mountings_type_pname), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "品牌",
                "min-width": "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_21, _toDisplayString(scope.row.mountings_brand_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "单位",
                "min-width": "100"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_22, _toDisplayString(scope.row.unit), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "采购单价",
                "min-width": "125",
                align: "center"
              }, {
                default: _withId((scope) => [
                  _createVNode(_component_el_input, {
                    modelValue: scope.row.unit_price,
                    "onUpdate:modelValue": ($event: any) => (scope.row.unit_price = $event),
                    type: "text",
                    style: {"width":"80px","text-align":"center"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "数量",
                "min-width": "125",
                align: "center"
              }, {
                default: _withId((scope) => [
                  _createVNode(_component_el_input, {
                    modelValue: scope.row.number,
                    "onUpdate:modelValue": ($event: any) => (scope.row.number = $event),
                    type: "text",
                    class: "mar-l-16",
                    style: {"width":"80px"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["partsData", "onBtn_add"])),
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx._onsubmit
        }, {
          default: _withId(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_dialog, {
        "model-value": _ctx.car_dialog_show,
        width: 500,
        "before-close": _ctx.dia_beforclose
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            type: "text",
            "prefix-icon": "el-icon-search",
            style: {"width":"180px"},
            placeholder: "输入车牌号码搜索",
            modelValue: _ctx.dialog_search,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialog_search = $event)),
            onChange: _ctx.get_dialog_data
          }, null, 8, ["modelValue", "onChange"]),
          _withDirectives(_createVNode(_component_el_table, {
            class: "mar-t-10",
            data: _ctx.dialog_data,
            stripe: "",
            border: "",
            style: {"width":"100%"},
            "max-height": "350",
            onCurrentChange: _ctx._table_select_carcode,
            onSelectionChange: _ctx.handleSelectionChange,
            "header-cell-style": "{background-color: #f2f5f9, height: 48px, text-align: center}"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "ordersn",
                label: "单据编号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "car_code",
                label: "车牌号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "category_name",
                label: "车辆型号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "meet_vehicle",
                label: "接车人",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "create_time_text",
                label: "开单时间",
                "min-width": 84
              })
            ]),
            _: 1
          }, 8, ["data", "onCurrentChange", "onSelectionChange"]), [
            [_directive_loading, _ctx.dialog_isload]
          ])
        ]),
        _: 1
      }, 8, ["model-value", "before-close"]),
      _createVNode(_component_el_dialog, {
        center: "",
        title: "添加配件",
        modelValue: _ctx.dialog_show.parts,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.dialog_show.parts = $event)),
        width: 900
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_26, [
            _withDirectives(_createVNode("div", null, [
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_el_input, {
                  style: {"width":"202px"},
                  modelValue: _ctx.dialogSelect.search,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogSelect.search = $event)),
                  placeholder: "项目名称/拼音首字母",
                  clearable: "",
                  class: "mar-r-18",
                  "suffix-icon": "el-icon-search",
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogSelectChange($event, 'search')))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_el_table, {
                data: _ctx.partsTable,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                "highlight-current-row": _ctx.is_all,
                onCurrentChange: _ctx.handleCurrentChange,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withId(() => [
                  (_ctx.is_all)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        type: "selection",
                        width: "55"
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange", "onSelectionChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 0]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_form, {
                "label-width": "100px",
                model: _ctx.partsForm,
                rules: _ctx.partsRules,
                ref: "partsFormNode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "配件名称",
                    prop: "name"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.name,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.partsForm.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "规格",
                    prop: "specification"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.specification,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.partsForm.specification = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "编码",
                    prop: "encoding"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.encoding,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.partsForm.encoding = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "销售价",
                    prop: "price"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.price,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.partsForm.price = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "单位",
                    prop: "unit_id"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.partsForm.unit_id,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.partsForm.unit_id = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_unit_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "返现方案",
                    prop: "return_cash_plan"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.partsForm.return_cash_plan,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.partsForm.return_cash_plan = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addService(false)))
                }, {
                  default: _withId(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.partsDialog = false))
                }, {
                  default: _withId(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 1]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_directive_loading, _ctx.is_load]
    ])
  ]))
})